import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";
import { Icon } from "components/atoms";
import { IconName } from "interfaces/icons";

const Container = styled.div`
	background: transparent;
	padding: 20px;
	display: flex;
	flex-direction: column;
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	border-radius: 8px;
	transition: all 0.2s ease-in-out;
	position: relative;

	@media (max-width: 768px) {
		padding: 15px;
	}
`;

const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 12px;

	@media (max-width: 768px) {
		margin-bottom: 8px;
	}
`;

const Title = styled.p`
	font-size: 14px;
	font-family: "Open Sans Medium", sans-serif;
	color: ${MAIN_THEME.TEXT_SECONDARY};
	font-weight: 600;
	text-transform: none;
	letter-spacing: 0.5px;

	@media (max-width: 768px) {
		font-size: 12px;
	}
`;

const IconWrapper = styled.div`
	opacity: 0.7;
`;

const Value = styled.p<{ isDestructive?: boolean }>`
	font-size: 24px;
	margin-top: auto;
	bottom: 50%;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	font-weight: 700;

	@media (max-width: 768px) {
		font-size: 18px;
	}
`;

const Value2 = styled.p`
	font-size: 11px;
	margin-top: 6px;
	color: ${MAIN_THEME.TEXT_SECONDARY};
	font-weight: 400;

	@media (max-width: 768px) {
		font-size: 10px;
	}
`;

interface Props {
	value: number | string;
	value1: number | string;
	value2: number | string;
	title: string;
	icon?: IconName;
	isDestructive?: boolean;
}

const SummaryItemThreeValues = (props: Props) => {
	const { value, title, value1, value2, icon, isDestructive } = props;

	// Helper to format title case (first letter capital, rest lowercase, keeping abbreviations)
	const formatTitle = (text: string) => {
		// List of known abbreviations to keep uppercase
		const abbreviations = ["ADR", "ALOS", "KPI", "USD", "AMD", "RevPAR"];
		
		if (abbreviations.includes(text)) return text;
		
		// For RevPAR specifically since it's mixed case in the requirement "RevPAR" but typically "RevPAR"
		if (text === "RevPAR") return "RevPAR";

		return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
	};

	const displayTitle = formatTitle(title);

	return (
		<Container>
			<Header>
				<Title>{displayTitle}</Title>
				{icon && (
					<IconWrapper>
						<Icon name={icon} size={18} color={MAIN_THEME.TEXT_TERTIARY} />
					</IconWrapper>
				)}
			</Header>
			<Value isDestructive={isDestructive}>{value}</Value>
			<Value2>{value1}</Value2>
			<Value2>{value2}</Value2>
		</Container>
	);
};

export default SummaryItemThreeValues;
